// ContactUsSection.tsx

import ContactUsCard from "@components/BasicComponents/Cards/ContactUsCard/ContactUsCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import {
	AdvancedSideAssetModuleType,
	ContactUsCardModuleType,
	ContactUsCardType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

import styles from "./ContactUsSection.module.scss"

const ContactUsSection = (props: {
	data?: AdvancedSideAssetModuleType
	cards: ContactUsCardModuleType
	backgroundColor?: "white"
}) => {
	const cards = props.cards.cards
	return (
		<section>
			<ContainerWrapper>
				<Title
					className={styles.cardsCeoSectionTitle}
					content={
						props.data?.sectionTitle ? props.data?.sectionTitle : ""
					}
					size={"M"}
					withoutPadding={!props.data?.sectionTitle}
				/>
				<Paragraph
					className={styles.cardsCeoTitle}
					content={props.data?.sectionSubtitle}
					size={"M"}
				/>

				<Separator
					className={styles.contactContainer}
					size={props.backgroundColor ? 8 : 32}
				>
					{cards.map((element: ContactUsCardType, index: number) => {
						return (
							<ContactUsCard
								key={index}
								backgroundColor={props.backgroundColor}
								className={styles.contactCardContainer}
								data={element}
							/>
						)
					})}
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default ContactUsSection
